/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type Row_job$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type Jobs_organization$ref: FragmentReference;
declare export opaque type Jobs_organization$fragmentType: Jobs_organization$ref;
export type Jobs_organization = {|
  +name: string,
  +slug: string,
  +jobs?: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +id?: string,
        +$fragmentRefs: Row_job$ref,
      |}
    |}>,
    +pageInfo: ?{|
      +hasNextPage: boolean
    |},
  |},
  +$refType: Jobs_organization$ref,
|};
export type Jobs_organization$data = Jobs_organization;
export type Jobs_organization$key = {
  +$data?: Jobs_organization$data,
  +$fragmentRefs: Jobs_organization$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "agentQueryRules"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "concurrency"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isMounted"
    },
    {
      "defaultValue": 50,
      "kind": "LocalArgument",
      "name": "pageSize"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "passed"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "priority"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "states"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "Jobs_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "condition": "isMounted",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "agentQueryRules",
              "variableName": "agentQueryRules"
            },
            {
              "kind": "Variable",
              "name": "concurrency",
              "variableName": "concurrency"
            },
            {
              "kind": "Variable",
              "name": "first",
              "variableName": "pageSize"
            },
            {
              "kind": "Variable",
              "name": "passed",
              "variableName": "passed"
            },
            {
              "kind": "Variable",
              "name": "priority",
              "variableName": "priority"
            },
            {
              "kind": "Variable",
              "name": "state",
              "variableName": "states"
            },
            {
              "kind": "Literal",
              "name": "type",
              "value": "COMMAND"
            }
          ],
          "concreteType": "JobConnection",
          "kind": "LinkedField",
          "name": "jobs",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "JobEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "id",
                          "storageKey": null
                        }
                      ],
                      "type": "JobTypeCommand",
                      "abstractKey": null
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "Row_job"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '188f4501a1883ff98f1df52ab84479e4';

module.exports = node;
